import styled from 'styled-components';

export const TitleSection = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px',
});

export const FileCount = styled.span({
    color: '#6B7280',
    fontSize: '14px',
});

export const UploadArea = styled.div({
    border: '1px dashed #E5E7EB',
    borderRadius: '8px',
    padding: '8px 12px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    cursor: 'pointer',
    backgroundColor: '#F9FAFB',
    width: '60%',
    minHeight: '40px',
});

export const UploadContent = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
});

export const UploadText = styled.p({
    margin: 0,
    color: '#6B7280',
    fontSize: '14px',
});

export const NoticeText = styled.p({
    margin: 0,
    color: '#6B7280',
    fontSize: '12px',
    fontStyle: 'italic',
});

export const FileList = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
});

export const FileItem = styled.div({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '8px 12px',
    backgroundColor: '#FFFFFF',
    border: '1px solid #E5E7EB',
    width: '60%',
    borderRadius: '8px',
});

export const FileInfo = styled.div({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    color: '#374151',
    fontSize: '14px',
    cursor: 'pointer',
    wordBreak: 'break-word',
    whiteSpace: 'normal',
    flex: 1,
    '&:hover': {
        textDecoration: 'underline',
    },
});

export const DeleteButton = styled.button({
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#6B7280',
    padding: '4px',
    display: 'flex',
    alignItems: 'center',
    '&:hover': {
        color: '#EF4444',
    },
});
